import React from 'react';
import { PageWrapper } from 'app/components/Core';
import { Box, Skeleton, SkeletonCircle } from '@chakra-ui/react';

export const ProfileTopSectionLoader: React.FC = () => (
  <PageWrapper maxHeight={175} p={0} overflow="hidden">
    <Box display="flex">
      <SkeletonCircle width={128} height={128} />
      <Box display="flex" flexDir="column" ml={4} justifyContent="center">
        <Skeleton
          display="inline"
          width={200}
          height={5}
          mb={1}
          borderRadius={8}
        />
        <Skeleton display="inline" width={250} height={28.8} borderRadius={8} />
      </Box>
    </Box>
  </PageWrapper>
);
